import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getInfoSummary2WidgetStyles = () => {
  var spacing = tokens.spacing;
  return StyleSheet.create({
    cardStyle: {
      overflow: 'hidden'
    },
    buttonContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: spacing.SPACING_50
    },
    paddingTopBottom: {
      paddingVertical: spacing === null || spacing === void 0 ? void 0 : spacing.SPACING_16
    },
    productPadding: {
      padding: spacing === null || spacing === void 0 ? void 0 : spacing.SPACING_16
    },
    addBtnStyle: {
      minWidth: 140
    }
  });
};